import { Attributes } from '../../../shared/models/JsonApiWrap';
import { PaidForDetails } from '../../../shared/models/TrustFieldsRequestInfo';
import { individual } from '../ptrs/PaidFor';
import { CodeAndDescription } from '../shared/CodeAndDescription';
import { ContributionReason } from "./ContributionReason";
import { DistributionReason } from "./DistributionReason";
import { InternalTransferBaseRequest } from "./InternalTransferBaseRequest";
import { Position } from './Position';

export class InternalTransferListVerifyRequest implements Attributes<InternalTransferVerifyRequest> {
    attributes: InternalTransferVerifyRequest;
    type: string;
    id: string;
}

export class InternalTransferVerifyRequest extends InternalTransferBaseRequest {
    bsloaTransaction: boolean = false;
    stateTaxAttentionRequired: boolean = false;
    amount: string = '0';
    amountType: string = '';
    processDate: string = '';
    isIraTransaction: boolean = false;
    isWithholdFedTax: boolean = false;
    fedTaxAmount: string = '0';
    isWithholdStateTax: boolean = false;
    stateTaxAmount: string = '0';
    isSloaPopupSelected: boolean = false;
    isCreateSloa: boolean = false;
    nickname: string = '';
    isRecurringTransaction: boolean= false;
    process2ndDate: string = '';
    endDate: string = '';
    isTrust?: boolean = false;
    paidFor: individual;
    trustIncmPct: string = '';
    trustIncmToPct: string = '';
    trustPrinPct: string = '';
    trustPrinToPct: string = '';
    trustTaxCode: string = '';
    trustTaxCategory: string = '';
    trustDepositCode: string = '';
    depositTaxCode: string = '';
    toPrincipal: string = '';
    toIncome: string = '';
    selectedCostBasisMethod: string = '';
    defaultCostBasisMethod: string = '';
    selectedPositionsCount: number= 0;
    selectedLotsCount: number= 0;
    selectedPositionsList: Position[] = [];
    isLoaOnFile: boolean = false;
    isEdit: boolean = false;
    cashieringNoteText: string = '';
    stockHandlerId: number= 0;
    tranMemo: string = '';
    distributionReason: DistributionReason;
    payIncome: CodeAndDescription;
    frequency: CodeAndDescription;
    iraContributionType: ContributionReason;
    toAccountId: string = '';
    cashieringRequestId: number= 0;
    cashieringSecondRequestId: number= 0;
    draftId: string;
    stateCd: string;

    public constructor(init?: Partial<InternalTransferVerifyRequest>) {
        super();
        Object.assign(this, init);
    }
}
